import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';

import { authInterceptor } from './interceptor/auth.interceptor';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideClientConfig } from './provider/provide-client-config';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideHttpClient(
            withFetch(),
            withInterceptors([authInterceptor])
        ),
        provideClientHydration(),
        provideClientHydration(withEventReplay()),
        ...provideClientConfig()
    ],
};
